export class PatientDashboardRoutingRouteNames {
    public static readonly PatientIdParam = 'patientId';
}
